import './modal-users-creation-duplicate.scss';

export default class ModalUsersCreationDuplicateController {
	/* @ngInject */
	/**
	 * @param {import('angular').ITimeoutService} $timeout
	 * @param {import('angular').ui.bootstrap.IModalInstanceService} $uibModalInstance
	 * @param {import('~/scripts/services/model/link').default[]} links
	 */
	constructor(
		$timeout,
		$uibModalInstance,
		links,
	) {
		this.$timeout = $timeout;
		this.$uibModalInstance = $uibModalInstance;
		this.links = links;

		/** @type {import('@knitiv/api-client-javascript').KNode | '__create' | undefined} */
		this.profil = undefined;
	}

	cancel() {
		this.$uibModalInstance.dismiss('cancel');
	}

	submit() {
		this.$uibModalInstance.close({
			profil: this.profil,
		});
	}
}
